import { render, staticRenderFns } from "./DashboardAuthorTasks.vue?vue&type=template&id=7c6e77d8&"
import script from "./DashboardAuthorTasks.vue?vue&type=script&lang=js&"
export * from "./DashboardAuthorTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports